import { useEffect } from 'react';
import fetchIntercept from 'fetch-intercept';

export default function useInterceptHealthyAuth({ forceLogout }) {
  useEffect(() => {
    const unregister = fetchIntercept.register({
      response(response) {
        if (response.status === 401 && response.url.includes('healthy.io')) {
          forceLogout();
          return Promise.reject(new Error('Unauthorized'));
        }

        return response;
      },
    });

    return () => {
      unregister();
    };
  }, []);
}
